import api from './api';

export interface Level {
  id: number;
  name_french?: string;
  name_english?: string;
}

export const levelsService = {
  // Get all levels
  getAllLevels: async (): Promise<Level[]> => {
    try {
      const response = await api.get('/levels');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get level by ID
  getLevelById: async (id: number): Promise<Level> => {
    try {
      const response = await api.get(`/levels/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};
